import PropTypes from "prop-types";
import { SERIES_CONFIG } from "../constants";
import "./ChartLegend.scss";

const ChartLegend = ({ visibility, onToggle }) => {
  return (
    <div className="chart-legend">
      {SERIES_CONFIG.map(cfg => (
        <div
          key={cfg.name}
          role="button"
          tabIndex={0}
          onClick={() => onToggle(cfg.name)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggle(cfg.name);
            }
          }}
          className={`chart-legend__item ${!visibility[cfg.name] ? "chart-legend__item--hidden" : ""}`}
        >
          <div className="chart-legend__swatch" style={{ backgroundColor: cfg.color }} />
          <span className="chart-legend__label">{cfg.name}</span>
        </div>
      ))}
    </div>
  );
};

ChartLegend.propTypes = {
  visibility: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default ChartLegend;
